import { getStockSnapshot } from '@/components/sale/product-sale-utils';
import { Product, ProductVariant } from '@/types/product-type';
import { PinnedVariantWithStock } from '@/types/sale-type';

export function toPinnedStock(
  variant: ProductVariant,
  product: Product,
): Omit<PinnedVariantWithStock, 'id' | 'product' | 'variant'> {
  const snapshot = getStockSnapshot(variant, product);
  return {
    remain: snapshot.remain,
    total: snapshot.total,
    sold: snapshot.sold,
    low:
      snapshot.remain > 0 &&
      snapshot.remain <=
        Math.max(3, Number.isFinite(variant.stock) ? Math.round(snapshot.remain * 0.1) : 0),
    out: snapshot.remain === 0,
  };
}

export function toPinnedVariantStub(
  variantId: string,
  product: Product,
  variant: ProductVariant,
): PinnedVariantWithStock {
  return {
    id: variantId,
    product,
    variant,
    ...toPinnedStock(variant, product),
  };
}

/** Keep client tab order; refresh pin data from server without reordering tabs. */
export function mergePinCacheByOrder(
  orderedIds: string[],
  serverData: PinnedVariantWithStock[],
  currentCache: PinnedVariantWithStock[],
): PinnedVariantWithStock[] {
  const serverMap = new Map(serverData.map((v) => [v.id, v]));
  const cacheMap = new Map(currentCache.map((v) => [v.id, v]));
  return orderedIds
    .map((id) => serverMap.get(id) ?? cacheMap.get(id))
    .filter((v): v is PinnedVariantWithStock => v != null);
}
